import * as React from "react";

import { CQMCheck } from "@eave/shared/types/api";

const { OverlayTrigger, Tooltip } = require("react-bootstrap");

const EMDASH = <span className="cqm-info-review__emdash">—</span>;
const INSUFFICIENT_INFO = <Tooltip id="tooltip">Insufficient info</Tooltip>;

const moneyWithCommas = money => {
  const parts = money.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

const CQMCheckSection = (props: CQMCheck) => (
  <table className="cqm-info-review__values-table">
    <tbody>
      {props.values &&
        props.values.map(v => {
          const { type } = props;

          // don't use custom components for money or rate, to make sure we show
          // real backend values and don't do any subtle rounding or truncation
          let val;
          if (!v.sufficient_info || val === "") {
            val = EMDASH;
          } else if (type === "money") {
            val = `$${moneyWithCommas(v.value)}`;
          } else if (type === "rate") {
            val = `${v.value}%`;
          } else {
            val = v.value;
          }

          return (
            <tr key={v.source} className="cqm-info-review__values-table-row">
              <td className="cqm-info-review__insufficient-info">
                {!v.sufficient_info && (
                  <OverlayTrigger placement="top" overlay={INSUFFICIENT_INFO}>
                    <i className="fa fa-question" />
                  </OverlayTrigger>
                )}
              </td>
              <td>{v.source}</td>
              <td>{val}</td>
            </tr>
          );
        })}
    </tbody>
  </table>
);

export default CQMCheckSection;
